//Events when navigation back
window.addEventListener('popstate', function (e) {
   var page = e.state;
   closeAjaxContainer();
   if (page == null) {
   } else {
      //close active open window
      closeAjaxContainer();
   }
});


function mobileCheck() {
  return ( ( window.innerWidth <= 1024 ) );
}


function insertWidget() {
   if (!document.getElementById('tebi')) {
      var script = document.createElement('script');
      script.src = "https://live.tebi.co/ecom/widget-manager.js";
      script.setAttribute("data-widget-token", "167390_93566e71491820692a85fb65aaa1ac81e48bd738ae01163f2a4f329959162c0a");
      script.id = "tebi";
      document.querySelector('.page').appendChild(script);
   }
}


insertPageContainer = function (url, element, target) {

  const navMain = document.querySelector('.nav-main');

   var currentUrl = window.location.href;
   // Find the index of the first occurrence of :// in the URL
   var index = currentUrl.indexOf('://');

   // Remove the protocol from the URL
   var urlWithoutProtocol = currentUrl.substring(index + 1);

   console.log(url);
   console.log(urlWithoutProtocol);

   if (url !== urlWithoutProtocol) {
       // 'url' is not the current page URL
       console.log("The URL is not the same as the current page URL.");
       //Only close menu
       navMain.classList.remove('open');

   } else {
      // 'url' is the current page URL
      //Only close menu
      navMain.classList.remove('open');
      return;

   }

   var pageSlug = element.getAttribute('data-page');
   var newContainer = document.createElement('div');

    element.classList.add('disabled');

    if (target == 'left') {
      //Add color
      // Select all elements with the class 'nav-link'
      const navLinks = document.querySelectorAll('.nav-link');

      // Loop through each element and remove the 'active' class
      navLinks.forEach(navLink => {
        navLink.classList.remove('active');
      });
      //Set class to active
      element.classList.add('active');

      //Set Global Color by setting a body attr (for other elements);
      const body = document.querySelector('body');
      body.setAttribute('data-page', pageSlug);

    }

    if (target == 'right') {
      // Find all elements with the class 'event'
      const eventElements = document.querySelectorAll('.event');

      // Loop through each 'event' element
      eventElements.forEach(eventElement => {
          // Remove 'active' class from all 'event' elements
          eventElement.classList.remove('active');

          // Find the closest parent element with the class 'event'
          const closestParentEvent = element.closest('.event');

          // Add 'active' class to the closest parent 'event' element
          if (closestParentEvent) {
              closestParentEvent.classList.add('active');
          }
      });
    }

    prevUrl = window.location.href;
    //find the parent
    parentElement = document.querySelector('.page__'+target);
    //Add Class to new Element to the correct parent
    newContainer.className =  'page__'+target+'__foldout injected';
    newContainer.classList.add(pageSlug);

    if (pageSlug == 'restaurant') {
      insertWidget();
    }

   //Fetch data
   fetch(url)
      .then(function (response) {
         //Get data as html/text
         return response.text();
      })
      .then(function (html) {
         //Fill the new container with content
         var parser = new DOMParser();
         var doc = parser.parseFromString(html, 'text/html');

         // Search for the div with class 'page-content'
         var pageContent = doc.querySelector('.fetch-content');

         newContainer.innerHTML = pageContent.innerHTML;
         //Re-Enable link
         element.classList.remove('disabled');
         parentElement.appendChild(newContainer);
         //Set Window URL -- disable during dev
         history.pushState(url, null, url);
      })
      .catch(function (err) {
         // There was an error
         console.warn('Something went wrong.', err);
      });
}; //insertPageContainer

document.addEventListener('click', (e) => {

  element = e.target;
  url = e.target.getAttribute('href');



   if (e.target.classList.contains('nav-link')) {
       e.preventDefault();
      insertPageContainer(url, element, 'left');
   } else if (e.target.classList.contains('event-link')) {
      e.preventDefault();
      if (mobileCheck() == true) {
        //dont fetch, just go there on mobile
        window.location.href = url;
      }

     insertPageContainer(url, element, 'right');
   } else if (e.target.classList.contains('single-content__close')) {
      closeAjaxContainer();
   }
});

document.addEventListener('click', (e) => {


});

closeAjaxContainer = function (element) {
   var singleContent = document.querySelectorAll('.page__right__foldout');
    singleContent.forEach(function(singleContent) {
        singleContent.remove();
    });
};



